import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { DEALRISK } from '../utils/constants'
import actions from '../actions/index'
import Skeleton from 'react-loading-skeleton'
import { stringToSEO } from '../utils/stringOps'

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

moment.locale('en-gb', {
  week: {
    dow: 1 // Monday is the first day of the week.
  }
})

const localizer = momentLocalizer(moment)

const customLabels = {
  month: 'Calendar View',
  agenda: 'List View',
  previous: 'Previous',
  event: 'Conference Title',
  noEventsInRange: 'There are no conferences for the selected date range.'
}

const formats = {
  agendaHeaderFormat: ({ start, end }, culture, localizer) =>
    localizer.format(start, 'D MMM YYYY', culture) + ' - ' + localizer.format(end, 'D MMM YYYY', culture),

  agendaDateFormat: (date, culture, localizer) =>
    localizer.format(date, 'ddd D MMM', culture)
}

export class Conference extends Component {
  constructor (props) {
    super(props)

        this.state = {
      events: [],
      fetched: false
    }
  }

  componentDidMount () {
    if (this.props.user) {
      this.props.onConferenceFetch().then(() => {
        var data = this.props.conferences.documents.map(conference => ({
          id: conference.contentId,
          title: conference.title,
          start: new Date(conference.eventDate),
          end: new Date(conference.eventDate),
          desc: conference.inBrief
        }))

        this.setState({ events: data, fetched: true })
      })
    }
  }

  render () {
    if (this.props.user && this.props.conferences.documents && this.props.conferences.fetching === false && this.state.fetched === true) {
      const appBaseUrl = `${process.env.APP_BASE_URL}`
      return (
        <div className='conference-listing grid-content-full'>
          <div className='inner-container'>
            <h1 className='section-header'>Conference Listings</h1>
            <p>The calendar below lists conferences run by third party organizations that are relevant to regulatory risk.  Please click on the conference title to view full details.<br /></p>
          </div>
          <br />
          <Calendar
            popup
            localizer={localizer}
            events={this.state.events}
            startAccessor='start'
            endAccessor='end'
            style={{ height: 600 }}
            onSelectEvent={event => window.open(`${appBaseUrl}/#/content/${event.id}/${stringToSEO(event.title)}?referrer=conferences_viewlisting`, '_self')}
            defaultDate ={new Date(new Date().getFullYear(), new Date().getMonth(), 1)}
            tooltipAccessor={event => event.title}
            views={['month', 'agenda']}
            messages={customLabels}
            formats={formats}
          />
        </div>
      )
    } else {
      return (
        <div className='grid-content-full skeleton'>
          <div className=''>
            <Skeleton height={2} count={1} /><br /><br />
            <Skeleton count={10} /><br /><br />
          </div>
        </div>
      )
    }
  }
}

function mapStateToProps (state) {
  document.title = 'MLex | Conference Listings'

  return {
    user: state.oidc.user,
    conferences: state.conferences
  }
}

const mapDispatchToProps = (dispatch) => ({
  onConferenceFetch: () => new Promise((resolve, reject) => {
    dispatch(actions.fetchConferences()).then(() => {
      resolve()
      })
  })
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Conference)
